export default __webpack_public_path__ + "static/media/_0002_listo.750b127c.png";